import { restClient } from '@/Core'

import { toNode } from '../Helpers/diskResponse'

import type { DiskNode } from '../Contracts/DiskNode'

/**
 * Нова папка: `POST /services/disk/folders`. `conflict: fail` — зайняту назву
 * людина бачить одразу й обирає іншу, а не отримує мовчазне «Назва (1)».
 */
export const CreateDiskFolderTask = async (parent: string, name: string): Promise<DiskNode> => {
    const response = (await restClient.post('/services/disk/folders', {
        json: { parent, name, conflict: 'fail' },
    })) as unknown

    return toNode(response)
}
